import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import BlockIcon from "@mui/icons-material/Block";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { logoutUser } from "../services/authService";

export default function SubscriptionSuspendedDialog() {
  const { darkMode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const supportEmail =
    process.env.REACT_APP_SUPPORT_EMAIL || "support@sparronix.com";

  return (
    <Dialog
      open
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      onClose={() => {}}
      aria-labelledby="subscription-suspended-title"
      aria-describedby="subscription-suspended-description"
      BackdropProps={{
        sx: {
          backgroundColor: darkMode
            ? "rgba(3, 8, 18, 0.78)"
            : "rgba(15, 23, 42, 0.62)",
          backdropFilter: "blur(5px)",
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          border: "1px solid",
          borderColor: darkMode ? "rgba(255,255,255,0.14)" : "#e2e8f0",
          background: darkMode ? "#111827" : "#ffffff",
          boxShadow: "0 24px 80px rgba(15, 23, 42, 0.28)",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        id="subscription-suspended-title"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: darkMode ? "#fca5a5" : "#b42318",
          fontWeight: 700,
          padding: "28px 28px 12px",
        }}
      >
        <BlockIcon />
        Account suspended
      </DialogTitle>
      <DialogContent
        id="subscription-suspended-description"
        sx={{
          color: darkMode ? "#cbd5e1" : "#475569",
          padding: "8px 28px 22px",
          lineHeight: 1.7,
        }}
      >
        Your account access is temporarily paused. The workspace remains
        visible, but all actions are disabled until your subscription is
        reactivated. Contact support for assistance.
      </DialogContent>
      <DialogActions
        sx={{
          padding: "16px 28px 24px",
          gap: 1,
          borderTop: "1px solid",
          borderColor: darkMode ? "rgba(255,255,255,0.1)" : "#eef2f7",
        }}
      >
        <Button
          component="a"
          href={`mailto:${supportEmail}`}
          variant="contained"
          startIcon={<EmailOutlinedIcon />}
          sx={{
            textTransform: "none",
            borderRadius: 1.5,
            backgroundColor: darkMode ? "#f87171" : "#b42318",
            "&:hover": {
              backgroundColor: darkMode ? "#ef4444" : "#912018",
            },
          }}
        >
          Contact support
        </Button>
        <Button
          onClick={() => logoutUser(dispatch)}
          variant="outlined"
          startIcon={<LogoutIcon />}
          sx={{ textTransform: "none", borderRadius: 1.5 }}
        >
          Log out
        </Button>
      </DialogActions>
    </Dialog>
  );
}